import Vue from "vue"
import Vuex from "vuex"
import Alerts from "./alerts"
import Accounts from "./accounts"
import ServiceTypeCategories from "./serviceTypeCategories"
import ClientServices from "./clientServices"
import Confirmation from "./confirmation"
import Content from "./content"
import Customers from "./customers"
import Plans from "./plans"
import Documents from "./documents"
import Funding from "./funding"
import Helper from "./helper"
import Incidents from "./incidents"
import Intervals from "./intervals"
import Invoices from "./invoices"
import Leave from "./leave"
import Loading from "./loading"
import MopaneApi from "./mopaneApi"
import Notifications from "./notifications"
import Pages from "./pages"
import Profile from "./profile"
import Users from "./users"
import Shifts from "./shifts"
import Vehicles from "./vehicles"
import Timeouts from "./timeouts"
import Toasts from "./toasts"

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        Alerts,
        Accounts,
        ServiceTypeCategories,
        ClientServices,
        Confirmation,
        Content,
        Customers,
        Plans,
        Documents,
        Funding,
        Helper,
        Incidents,
        Intervals,
        Invoices,
        Leave,
        Loading,
        MopaneApi,
        Notifications,
        Pages,
        Profile,
        Users,
        Shifts,
        Vehicles,
        Timeouts,
        Toasts
    }
})